import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Subscription } from 'rxjs';
import { SidenavService } from 'src/app/core/services/sidenav/sidenav.service';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { SideMenuItems } from 'src/app/shared/models/side-menu-items/side-menu-items';

@Component({
  selector: 'app-sidenav-content',
  templateUrl: './sidenav-content.component.html',
  styleUrls: ['./sidenav-content.component.scss'],
})
/**
 * Display the sidenav content
 * The menu is also part of this
 */
export class SidenavContentComponent implements OnInit {
  @ViewChild('sidenav') sidenav!: MatSidenav;
  sideMenuItems: SideMenuItems = new SideMenuItems();
  isMobile = true;
  private subsink = new Subscription();
  private _onlyDesktop = false;

  /**
   * @constructor
   */
  constructor(
    private sideNavService: SidenavService,
    private translationService: TranslationService,
    private readonly breakpointObserver: BreakpointObserver
  ) {}

  /**
   * ngOnInit()
   */
  ngOnInit() {
    this.translationService.translateSideMenuItems(this.sideMenuItems);
    this.sideNavService.sideNavToggleSubject.subscribe(() => {
      if (this.sidenav) {
        this.sidenav.toggle();
      }
    });

    this.subsink.add(
      this.breakpointObserver
        .observe(['(min-width: 620px)'])
        .subscribe((state: BreakpointState) => {
          this.isMobile = !state.matches;
        })
    );
  }

  /**
   * Decides if some css attributes appears only in desktop
   * @return {boolean}
   */
  @Input()
  get onlyDesktop(): boolean {
    return this._onlyDesktop;
  }

  /**
   * Sets the attributes by using an html attribute
   * @param {any} value
   */
  set onlyDesktop(value: any) {
    this._onlyDesktop = coerceBooleanProperty(value);
  }
}
